var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdminA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=\xEA\xB4\x80\xEB\xA6\xAC\xEC\x9E\x90, \xEC\x83\x81\xED\x83\x9C=hover"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.982 5.37503C18.9682 5.2148 18.6105 4.90708 18.4592 4.85219C18.3075 4.79697 18.1376 4.83456 18.0235 4.94809L15.7339 7.23769L12.7599 4.26374L15.0954 1.93712C15.2096 1.82337 15.2469 1.65413 15.1919 1.50324C15.1363 1.35205 14.7696 1.03175 14.6084 1.01787C13.1901 0.89613 11.8004 1.40061 10.7956 2.40174C9.41951 3.77278 9.05509 5.77488 9.7004 7.48143C9.62987 7.54063 9.56028 7.60336 9.49162 7.671L1.69603 14.9993C1.69328 15.002 1.69057 15.0049 1.68759 15.0075C0.770802 15.9209 0.770802 17.407 1.68759 18.3206C2.60453 19.2339 4.08537 19.2228 5.00201 18.3094C5.00596 18.3057 5.00958 18.302 5.01319 18.2979L12.305 10.4712C12.3715 10.4047 12.4332 10.3351 12.4914 10.2637C14.2049 10.9077 16.2158 10.5455 17.5931 9.1736C18.5977 8.1724 19.1044 6.78782 18.982 5.37503Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdminA);
export default __webpack_public_path__ + "static/media/Icon_admin_a.04af3aa93c6fe0d0360455e574df7a56.svg";
export { ForwardRef as ReactComponent };